import classes from "./forms.module.css";
import {useCallback, useEffect} from "react";

const Form = ({title, onClose, onSubmit, children}) => {

    const close = useCallback(() => {
        onClose();
    }, [onClose]);

    useEffect(() => {
        const handleKeyEsc = (evt) => {
            if (evt.key === 'Escape') {
                onClose();
            }
        }
        window.addEventListener('keydown', handleKeyEsc);
        return () => window.removeEventListener('keydown', handleKeyEsc);
    }, [onClose, close]);

    return (
        <div className={classes.overlay}>
            <div className={`${classes.modal}`}>
                <button className={classes.closeBtn} onClick={() => {
                    onClose();
                }} aria-label="Закрыть">
                    ✕
                </button>

                <h4 className={classes.title}>{title}</h4>
                <form onSubmit={onSubmit}>
                    {children}
                </form>
            </div>
        </div>
    )
}

export default Form